import { render, staticRenderFns } from "./UpdateValues.vue?vue&type=template&id=060889a8"
import script from "./UpdateValues.vue?vue&type=script&lang=js"
export * from "./UpdateValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports